export default "__VITE_ASSET__740d6972__"